import FullCalendar, { EventClickArg, EventContentArg, EventMountArg } from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import { EventSource } from '../../types/eventSource';
import { PencilIcon } from '@heroicons/react/outline';
import ReactTooltip from 'react-tooltip';
import { findDOMNode } from 'react-dom';

type ReadonlyCalendarProps = {
    calendarEvents: EventSource[];
    eventClick?: ((arg: EventClickArg) => void);
}

const ReadonlyCalendar = ({ calendarEvents, eventClick }: ReadonlyCalendarProps): JSX.Element => {
    /**
   * Renders the calendar event content
   * @param info 
   * @returns 
   */
    const renderEventContent = (info: EventContentArg) => {
        return (
            <>
                <h4 data-tip={info.event.title}>
                    {info.event.extendedProps.notes?.toLowerCase() !== "no notes" && (
                        <PencilIcon
                            className='text-white w-3.5 inline-block ml-0.5 mr-0.5'
                        />
                    )}
                    {info.event.title}
                </h4>
                <ReactTooltip />
            </>
        )
    }

    /**
     * Sets the events color on component mount (only once)
     * @param info EventMountArg
     */
    const renderEvent = (info: EventMountArg) => {
        const domNode = findDOMNode(info.el) as HTMLElement;
        if (info.backgroundColor && domNode) {
            domNode.style.backgroundColor = info.backgroundColor;
        }
    }

    return (
        <div className="read-only-calendar">
            <FullCalendar
                editable={false}
                selectable={false}
                plugins={[dayGridPlugin]}
                initialView="dayGridMonth"
                events={calendarEvents}
                eventContent={renderEventContent}
                displayEventTime={false}
                eventStartEditable={false}
                expandRows={true}
                longPressDelay={10}
                height="auto"
                eventClick={eventClick}
                eventDidMount={renderEvent}
            />
        </div>
    );
};

export default ReadonlyCalendar;